export const routerData = require("./routerData.json");
